export const mutations = {
  bootstrap (state) {
    state.isBootstrapped = true
  },
  setLoading (state, isLoading) {
    state.loading = isLoading
  },
  refreshCart (state, data) {
    state.loading = false

    if (data.errors) {
      state.app.cart.errors = data.errors
    } else {
      state.app.freeGiftTotalGoal = data.total_price
      state.app.cart = data
    }
  },
  toggleMiniCart (state) {
    if (state.app.isMiniCartOpen && state.app.modalToggleEl) {
      state.app.modalToggleEl.focus()
    }
    state.app.isMiniCartOpen = !state.app.isMiniCartOpen
  },

  updateGiftMessage (state, message = null) {
    state.app.cart.note = message
  },

  giftMessageState (state, updated = false) {
    state.giftMessageEdited = updated
  }
}
